import { render, staticRenderFns } from "./DashboardNews.vue?vue&type=template&id=f3a4b5e8"
import script from "./DashboardNews.vue?vue&type=script&lang=js"
export * from "./DashboardNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports